import { render, staticRenderFns } from "./HardwareWallet.vue?vue&type=template&id=28547dba&"
import script from "./HardwareWallet.vue?vue&type=script&lang=js&"
export * from "./HardwareWallet.vue?vue&type=script&lang=js&"
import style0 from "./HardwareWallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports